import fetchWrapper from "src/utils/fetchWrapper";
import { AuthSelectors } from "src/redux/Auth/selectors";
import { MD } from "./types";
import { ToasterActions } from "src/redux/Toaster/actions";
import CurrencyConverter from "src/utils/CurrencyConversionService";

export const MdActions = {
    /**
     *  Stocks
     */
    GetMarketData: (stockSymbol) => {
        return (dispatch, getState) => {
            return dispatch(
                fetchWrapper(
                    AuthSelectors.BuildMarketDataUrl(getState(), stockSymbol)
                )
            )
                .then((result) => {
                    return dispatch({
                        type: MD.MARKET_DATA_UPDATE,
                        result,
                        stockSymbol,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: MD.MD_ERROR,
                        stockSymbol,
                        error: error.message,
                    });
                });
        };
    },
    GetMarketDataBatch: (listTicker) => {
        return (dispatch, getState) => {
            return dispatch(
                fetchWrapper(
                    AuthSelectors.MarketDataBatchUrl(getState()),
                    {
                        method: "POST",
                        body: JSON.stringify(listTicker),
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                    },
                    1
                )
            )
                .then((result) => {
                    return result;
                })
                .catch((error) => {
                    dispatch(
                        ToasterActions.NewError("Error at Fetching Market Data")
                    );
                });
        };
    },

    SearchSecurities: (searchString) => {
        return (dispatch, getState) => {
            return dispatch(
                fetchWrapper(
                    AuthSelectors.BuildSecuritySearchUrl(getState()),
                    {
                        method: "PUT",
                        body: JSON.stringify({
                            /// NOTE: This API has full support for pagination, add this later if necessary.
                            searchString,
                            limit: 50,
                            startingAfter: undefined,
                        }),
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                    },
                    1
                )
            )
                .then((result) => {
                    return Promise.resolve(result);
                })
                .catch((error) => {
                    dispatch(
                        ToasterActions.NewError("Error at Fetching Market Data")
                    );
                });
        };
    },

    GetTreadeableDates: (batchStockSymbols) => {
        return (dispatch, getState) => {
            return dispatch(
                fetchWrapper(
                    AuthSelectors.MarketDataBatchUrl(getState()),
                    {
                        method: "POST",
                        body: JSON.stringify(batchStockSymbols),
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                    },
                    1
                )
            )
                .then((result) => {
                    let tradeableDates = {};
                    Object.keys(result).forEach((key) => {
                        tradeableDates[key] = result[key].data.tradableDates;
                    });
                    return Promise.resolve({ tradeableDates });
                })
                .catch((error) => {
                    dispatch(
                        ToasterActions.NewError("Error at Fetching Market Data")
                    );
                });
        };
    },

    /**
     *  Reference Data
     */
    GetRefData: (stockId, optionalDate) => {
        return (dispatch, getState) => {
            dispatch({
                type: MD.MD_SET_REF_FETCH_STATUS,
                isFetching: true,
            });

            return dispatch(
                fetchWrapper(
                    AuthSelectors.BuildMarketRefDataUrl(
                        getState(),
                        stockId,
                        optionalDate
                    )
                )
            )
                .then((result) => {
                    dispatch({
                        type: MD.MD_SAVE_REF_DATA,
                        data: result,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: MD.MD_SET_REF_FETCH_STATUS,
                        isFetching: false,
                        error: error,
                    });
                });
        };
    },

    ToggleRefSidebar: (shouldOpen) => ({
        type: MD.MD_TOGGLE_REF_SIDEBAR,
        shouldOpen,
    }),

    ResetRefSidebar: () => ({ type: MD.MD_RESET_REF }),

    /**
     *  Exchange Rates
     */
    GetAllExchangeRates: () => {
        return (dispatch, getState) => {
            return dispatch(
                fetchWrapper(AuthSelectors.BuildExchangeRatesUrl(getState()))
            )
                .then((result) => {
                    const rates = result.reduce(
                        (ratesByCode, e) => ({
                            ...ratesByCode,
                            [e.code]: e.previousClose,
                        }),
                        {}
                    );

                    CurrencyConverter.setExRates(rates, "USD");

                    return dispatch({
                        type: MD.MD_SET_EX_RATES,
                        rates,
                    });
                })
                .catch((error) => {
                    dispatch(
                        ToasterActions.NewError(
                            "Error at Fetching Exchange Rates"
                        )
                    );
                });
        };
    },
};
